import { HotelParams } from '@/models/HotelParams';

/**
 * Validazione input: restituisce una mappa campo → messaggio di errore.
 * Se la mappa è vuota, i parametri sono validi.
 */
export function validateParams(p: HotelParams): Partial<Record<keyof HotelParams, string>> {
  const errors: Partial<Record<keyof HotelParams, string>> = {};

  if (!Number.isFinite(p.rooms) || p.rooms <= 0) errors.rooms = 'Inserire un numero positivo di stanze.';
  if (!Number.isFinite(p.occupancy) || p.occupancy < 0 || p.occupancy > 1)
    errors.occupancy = 'L’occupazione deve essere tra 0% e 100%.';
  if (!Number.isFinite(p.manualMinutesPerRoom) || p.manualMinutesPerRoom < 0 || p.manualMinutesPerRoom > (24 * 60))
    errors.manualMinutesPerRoom = 'I minuti per stanza/giorno devono essere tra 0 e 1440.';
  if (!Number.isFinite(p.daysPerYear) || p.daysPerYear < 1 || p.daysPerYear > 366)
    errors.daysPerYear = 'I giorni/anno devono essere tra 1 e 366.';
  if (!Number.isFinite(p.hourlyCost) || p.hourlyCost < 0) errors.hourlyCost = 'Il costo orario non può essere negativo.';
  if (!Number.isFinite(p.adr) || p.adr < 0) errors.adr = 'L’ADR non può essere negativo.';
  if (!Number.isFinite(p.deltaOccupancy) || p.deltaOccupancy < 0 || p.deltaOccupancy > 1)
    errors.deltaOccupancy = 'L’incremento ΔO deve essere tra 0% e 100%.';
  if (!Number.isFinite(p.systemAnnualCost) || p.systemAnnualCost < 0)
    errors.systemAnnualCost = 'Il costo del sistema non può essere negativo.';
  if (p.upsellingIncrease !== undefined && (!Number.isFinite(p.upsellingIncrease) || p.upsellingIncrease < 0))
    errors.upsellingIncrease = 'Valore % non valido.';

  return errors;
}
